import Axios from '../Axios';
import { fetchUser } from '../utils/fetchUser';

export const getManDocuMaq = async () => {
  try {
    const userInfo = fetchUser();

    const { data } = await Axios.get(
      `/docugeneral?empresa=${userInfo.empresa}`);
    return data;
  } catch (error) {
    return Promise.reject(error);
  }
};

export const getManDocuMaqFiltro = async (mandante, maquina, soloLogistica = false, soloObra = false, soloAnexo = false) => {
  try {
    const userInfo = fetchUser();

    const { data } = await Axios.get(
      `/mandocumaq/filtros?empresa=${userInfo.empresa}&idMandante=${mandante}&idMaquina=${maquina}&soloLogistica=${soloLogistica}&soloObra=${soloObra}&soloAnexo=${soloAnexo}`);
    return data;
  } catch (error) {
    return Promise.reject(error);
  }
};

export const updateManDocuMaqFile = async (id, fileData) => {
  try {
    const { data } = await Axios.patch(`/mandocumaq/${id}`, fileData);
    return data;
  } catch (error) {
    return Promise.reject(error);
  }
};


export const crearDocuGeneralBull = async (clienteData) => {
  try {

    const { data } = await Axios.post(
      '/mandocumaq/bull', clienteData
    );
    return data;
  } catch (error) {
    return Promise.reject(error);
  }
};

export const eliminarManDocuMaqFiltro = async (idMandante, idMaquina) => {
  try {
    const userInfo = fetchUser();

    const { data } = await Axios.delete(
      `/mandocumaq/filtros?empresa=${userInfo.empresa}&idMandante=${idMandante}&idMaquina=${idMaquina}`
    );

    return data;

  } catch (error) {
    return Promise.reject(error);
  }
};

export const updateDocuGeneral = async (clienteData) => {
  try {
    const userInfo = fetchUser();
    clienteData.empresa = userInfo.empresa;
    const { data } = await Axios.patch(
      `/docugeneral/${clienteData._id}`, clienteData
    );

    return data;
  } catch (error) {
    return Promise.reject(error);
  }
};

export const deleteDocuGeneral = (Id) => Axios.delete(`/docugeneral/${Id}`);
